module.exports = __webpack_public_path__ + "img/heb.05ebde49.jpeg";